import { useState } from 'react'

import { toast } from '@webapp/components/Notification'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useQueryFinancialAccountBankingDetails } from '../../models/useQueryFinancialAccountBankingDetails'

export const useFinancialAccountBankingDetailsButtonPresenter = ({
  financialAccountId,
}: {
  financialAccountId: number
}) => {
  const intl = useProcurifyIntl()

  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false)

  const { accountDetails } = useQueryFinancialAccountBankingDetails({
    financialAccountId,
    enabled: isDetailsModalOpen,
    onError: () => {
      toast.error({
        title: intl.formatMessage(messages.fetchingDetailsToastError),
      })
    },
  })

  const openFinancialAccountBankingDetailsModal = () => {
    setIsDetailsModalOpen(true)
  }
  const closeFinancialAccountBankingDetailsModal = () => {
    setIsDetailsModalOpen(false)
  }

  return {
    commands: {
      openFinancialAccountBankingDetailsModal,
      closeFinancialAccountBankingDetailsModal,
    },
    data: {
      accountDetails: accountDetails?.fields,
    },
    states: {
      isModalOpen: isDetailsModalOpen,
    },
  }
}
